export default function decimalPlaces(num) {
  var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) {
    return 2;
  }
  if (!match[1]) {
    return 2;
  }
  if (match[1].length > 4) {
    return 4;
  }
  if (match[1].length < 2) {
    return 2;
  }
  return match[1].length;
}
